import { render, staticRenderFns } from "./InvoiceBook2.vue?vue&type=template&id=079f5512"
import script from "./InvoiceBook2.vue?vue&type=script&lang=js"
export * from "./InvoiceBook2.vue?vue&type=script&lang=js"
import style0 from "./InvoiceBook2.vue?vue&type=style&index=0&id=079f5512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports